import dayjs, { Dayjs } from 'dayjs';

export const formatDateToShortDateString = (date: Dayjs) =>
  dayjs(date).format('MMM YYYY').toString();

export const formatDateToFullDateString = (date: Dayjs) =>
  dayjs(date).format('DD MMM YYYY').toString();
